////////////////////////////////////////////////////////////////////////////////
import React, { Component } from "react";
////////////////////////////////////////////////////////////////////////////////
import "./EwButton.css";
////////////////////////////////////////////////////////////////////////////////

class EwButton extends Component {
    render() {
        return (
            <>
                <div className="ew_circle">EW!</div>
            </>
        );
    };
};

export default EwButton;